import PropTypes from 'prop-types';
import React from 'react';

import ProgramIntakeEnrolmentStatus from '../../../../model/ProgramIntakeEnrolmentStatus';
import useEnumerableModel from '../../../data/hooks/useEnumerableModel';
import itemIdValue from '../../../itemIdValue';
import useT from '../../utils/Translations/useT';
import MultiselectFilter from './MultiselectFilter';

const ProgramIntakeEnrolmentStatusSelector = props => {
  const t = useT();

  const { options } = useEnumerableModel(ProgramIntakeEnrolmentStatus);

  return (
    <MultiselectFilter
      itemId={itemIdValue}
      options={options}
      title={t('Enrolment Status')}
      {...props}
    />
  );
};

ProgramIntakeEnrolmentStatusSelector.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.oneOf(ProgramIntakeEnrolmentStatus.BasicProps)),
    PropTypes.string,
  ]),
  onChange: PropTypes.func,
};

ProgramIntakeEnrolmentStatusSelector.defaultProps = {
  value: null,
  onChange: null,
};

export default ProgramIntakeEnrolmentStatusSelector;
